import type { APIConfig } from '@ps/web-core-api';
import { WMTDisconnectReason, connect } from '@ps/web-core-api';

import type { Store } from '../types';

const WMT_RECONNECT = 1000;

export const WMTConnection = (
  { getState, select, dispatch }: Store,
  overrides?: Partial<APIConfig>
) =>
  connect({
    requestDestination: '/service/',
    requestTimeout: select.config.get(getState()).requestTimeout ?? 20000,
    responseChannel: '/user/queue/messages',
    url: '/api/v0/websocket',
    sockJSOptions: { transports: ['websocket'] },
    getHeaders: () => {
      const { token } = select.session.get(getState());
      return token ? { authorization: `StarsWeb-Session ${token}` } : undefined;
    },
    getReconnect: (currentDelay: number, reason: WMTDisconnectReason) => {
      if (reason === WMTDisconnectReason.InvalidToken) {
        dispatch.session.clear();
      }
      if (!currentDelay) {
        return reason === WMTDisconnectReason.VelocityControl ? WMT_RECONNECT : 1;
      }
      return currentDelay === 1 ? WMT_RECONNECT : currentDelay * 2;
    },
    ...overrides
  });
